import React, { useState, useEffect } from 'react';
import { ChevronRight } from 'lucide-react';
import newsItemsData from '../data/newsItems.json';

const NewsArchive = () => {
  const [newsItems, setNewsItems] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedNews, setSelectedNews] = useState(null);
  const itemsPerPage = 10;

  useEffect(() => {
    setNewsItems(newsItemsData);
  }, []);

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = newsItems.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const handleNewsClick = (news) => {
    setSelectedNews(news);
  };

  const NewsDetail = ({ news, onClose }) => (
    <div className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full z-50">
      <div className="relative top-20 mx-auto p-5 border w-11/12 md:w-3/4 lg:w-1/2 shadow-lg rounded-md bg-white">
        <div className="flex items-center text-sm text-gray-500 mb-6">
          <button onClick={onClose} className="hover:underline">トップ</button>
          <ChevronRight size={16} className="mx-2" />
          <button onClick={onClose} className="hover:underline">お知らせ一覧</button>
          <ChevronRight size={16} className="mx-2" />
          <span>{news.title}</span>
        </div>
        <div className="mb-4">
          <span className="text-blue-600 mr-4">{news.date}</span>
          <span className="bg-blue-100 text-blue-600 px-2 py-1 rounded text-sm">{news.category}</span>
        </div>
        <h2 className="text-2xl font-bold mb-4">{news.title}</h2>
        <p className="whitespace-pre-wrap">{news.content}</p>
        <div className="text-center mt-6">
          <button onClick={onClose} className="px-4 py-2 bg-gray-200 text-gray-800 rounded hover:bg-gray-300">
            お知らせ一覧へ
          </button>
        </div>
      </div>
    </div>
  );

  return (
    <div className="bg-gray-100 min-h-screen pt-24">
      <div className="max-w-5xl mx-auto px-4 py-8">
        <div className="bg-white shadow-md rounded-lg p-6">
          <div className="flex items-center text-sm text-gray-500 mb-6">
            <button onClick={() => {/* ホームページへの遷移処理 */}} className="hover:underline">トップ</button>
            <ChevronRight size={16} className="mx-2" />
            <span>お知らせ一覧</span>
          </div>
          
          <div className="mb-6">
            <button className="bg-blue-600 text-white px-4 py-2 rounded mr-2">すべて</button>
            <button className="bg-white text-blue-600 border border-blue-600 px-4 py-2 rounded">お知らせ</button>
          </div>

          <div className="space-y-6">
            {currentItems.map((item) => (
              <div key={item.id} className="border-b pb-4 cursor-pointer" onClick={() => handleNewsClick(item)}>
                <div className="flex items-center mb-2">
                  <span className="text-blue-100 mr-4">{item.date}</span>
                  <span className="bg-blue-100 text-blue-600 px-2 py-1 rounded text-sm">{item.category}</span>
                </div>
                <span className="text-lg font-semibold hover:underline">
                  {item.title}
                </span>
              </div>
            ))}
          </div>

          <div className="flex justify-center mt-8">
            {Array.from({ length: Math.ceil(newsItems.length / itemsPerPage) }, (_, i) => (
              <button
                key={i}
                onClick={() => paginate(i + 1)}
                className={`mx-1 px-3 py-1 rounded ${
                  currentPage === i + 1 ? 'bg-blue-600 text-white' : 'bg-gray-200'
                }`}
              >
                {i + 1}
              </button>
            ))}
          </div>
        </div>
      </div>

      {selectedNews && <NewsDetail news={selectedNews} onClose={() => setSelectedNews(null)} />}
    </div>
  );
};

export default NewsArchive;